/**
 * 접속 통계 · 제외 IP 관리 — '내 현재 IP 추가' 버튼.
 * data-excluded-ip-fill="<ip>" 클릭 시 같은 폼의 IP 입력칸(data-excluded-ip-field)에 값을 채운다.
 * 실제 추가는 폼 제출(data-admin-ajax) 이 처리하므로 여기서는 입력칸 채움 + 포커스만.
 */
export function initAnalyticsExcludedIp(): void {
  document.querySelectorAll<HTMLButtonElement>("[data-excluded-ip-fill]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const ip = btn.dataset.excludedIpFill ?? "";
      if (!ip) return;
      const form = btn.closest("form");
      const field = form?.querySelector<HTMLInputElement>("[data-excluded-ip-field]");
      if (!field) return;
      field.value = ip;
      field.focus();
    });
  });
}
